import * as Yup from "yup";
const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])/;
const signUpValidationSchema = Yup.object({
  fullName: Yup.string()
    .matches(/^\w+( \w+)+$/, "Please enter a first name and last name only")
    .required("This field is required"),
  email: Yup.string().email("invalid Email").required("Email is Required"),
  // country: Yup.string().required("Country is required"),
  // phone: Yup.number("Must be a number").required("Phone Number is required"),
  password: Yup.string()
    .min(8, "Password must be at least minimum of 8 characters")
    .matches(
      passwordRegex,
      "Password must contain at least one number, one special character, one uppercase letter, and be at least 8 characters long."
    )
    .required("Password is required"),
});

export { signUpValidationSchema, passwordRegex };
